/**
 * Algoamtic
 * @author Adrien Crivellaro
 * @created 29/04/2019
 */

console.info(
  "%c Algomatic %c https://www.algomatic.fr/",
  ' font-weight: bold; color: white; background: black;', 'font-weight: normal; font-style: italic; color: gray;'
);
